/* eslint-disable no-redeclare */
import { z } from 'zod';

export const LookingForHelpExtensionDto = z.enum([
  'specific_situation',
  'helping_someone_else',
  'improve_coverage',
  'dental_vision_supplemental',
]);

export type LookingForHelpExtensionDto = z.infer<
  typeof LookingForHelpExtensionDto
>;
